export default "__VITE_ASSET__35cff9ad__"